import { render, staticRenderFns } from "./SelectClientDropdownDashboard.vue?vue&type=template&id=6ec82c53&"
import script from "./SelectClientDropdownDashboard.vue?vue&type=script&lang=js&"
export * from "./SelectClientDropdownDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports